import { CrudModel } from "./_crud";

export class NeedModel extends CrudModel {
	constructor() {
		super("admin/need", [], []);
	}

	async getSolutions(needId: string) {
		return this.get(`${needId}/solution`);
	}

	async getWithSolutions({ page, limit, searchParam }: any) {
		return this.get("with-solution", { page, limit, searchParam });
	}
}

export default new NeedModel();
